// extracted by mini-css-extract-plugin
export default {"root":"text-area__root","label":"text-area__label","invalid":"text-area__invalid","valid":"text-area__valid","error":"text-area__error"};